import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root',
})
export class ArrowDownIconService {

  render(isNew = false) {
    if (isNew === false) {
    return `<svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.12835 4.58706L0.751034 0.834482C0.461449 0.512721 0.689795 0 1.12268 0H7.87732C8.3102 0 8.53855 0.512722 8.24897 0.834483L4.87165 4.58706C4.67303 4.80775 4.32697 4.80775 4.12835 4.58706Z" fill="#9E9E9E"/>
      </svg>
    `;
    }
    if (isNew === true) {
      return `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 4C12.5523 4 13 4.44772 13 5V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V5C11 4.44772 11.4477 4 12 4Z" fill="black"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.29289 11.2929C4.68342 10.9024 5.31658 10.9024 5.70711 11.2929L12 17.5858L18.2929 11.2929C18.6834 10.9024 19.3166 10.9024 19.7071 11.2929C20.0976 11.6834 20.0976 12.3166 19.7071 12.7071L12.7071 19.7071C12.3166 20.0976 11.6834 20.0976 11.2929 19.7071L4.29289 12.7071C3.90237 12.3166 3.90237 11.6834 4.29289 11.2929Z" fill="black"/>
      </svg>      
      `;
    }
  }
}
